// extracted by mini-css-extract-plugin
export default {"list":"PassengersListWidget_list__TTIY+","controls":"PassengersListWidget_controls__fQQRJ"};